import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-iud5jf-0"
})(["margin-top:14px;text-align:center;"]);
export var Dot = styled.div.withConfig({
  displayName: "partials__Dot",
  componentId: "sc-iud5jf-1"
})(["display:inline-block;width:24px;height:6px;border-radius:3px;margin:2px;background-color:", ";transition:background-color 200ms linear;&:hover{background-color:", ";}cursor:pointer;"], function (_ref) {
  var isActive = _ref.isActive,
    theme = _ref.theme;
  return isActive ? theme.colors.primary : theme.colors.terciaryM;
}, function (_ref2) {
  var active = _ref2.active,
    theme = _ref2.theme;
  return active ? theme.colors.primary : theme.colors.primaryL;
});